import type { Client, RequestContext } from "../client";
import type { UpgradeConfigurationResource } from "../resources/upgradeConfigurationResource";
import { ConfigurationRepository } from "./configurationRepository";

export class UpgradeConfigurationRepository extends ConfigurationRepository<UpgradeConfigurationResource> {
    constructor(client: Client, requestContext: RequestContext) {
        super("UpgradeConfiguration", client, requestContext);
    }
}
